const DIMENSIONS_BUCKETS = [80, 250, 500, 750, 1000, 2000, 4000]

function findNextBucket(originalSize: number, boosted: number): number {
  const originalBucket = DIMENSIONS_BUCKETS.find(
    bucket => bucket >= originalSize,
  )
  let nextBucket = DIMENSIONS_BUCKETS.find(bucket => bucket >= boosted)

  if (nextBucket === originalBucket) {
    const currentIndex = DIMENSIONS_BUCKETS.indexOf(nextBucket!)
    nextBucket = DIMENSIONS_BUCKETS[currentIndex + 1]
  }

  return nextBucket || DIMENSIONS_BUCKETS[DIMENSIONS_BUCKETS.length - 1]
}

export function boostSize(
  size: number | `${number}`,
  boost: number | undefined,
): number | `${number}` {
  if (boost === undefined || boost <= 1) {
    return size
  }
  const boosted = Number(size) * boost
  return findNextBucket(Number(size), boosted)
}
